<!--
 * @title:
 * @fileName: PageTableItem
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/5/21 13:43
 * @modified By：
 * @version:     1.0$
 * @description: TODO
-->
<template>
        <el-table-column
                align="center"
                :prop="tableColumnAttribute.prop"
                :label="tableColumnAttribute.label"
                :min-width="tableColumnAttribute.minWidth || 180"
                show-overflow-tooltip
                :width="tableColumnAttribute.width">
            <template v-if="checkChildren(tableColumnAttribute.children)">
                <page-table-item v-for="(child, index) in tableColumnAttribute.children"
                                 :tableColumnAttribute="child"
                                 :key="indexKey + '_' + index" :key-index="indexKey + '_' + index"></page-table-item>
            </template>
        </el-table-column>
</template>

<script>
export default {
    name: "PageTableItem",
    components: {},
    props: {
        tableColumnAttribute: Object,
        indexKey: [Number, String]
    },
    methods: {
        checkChildren (children) {
           return(Array.isArray(children) && children.length > 0)
        },
        checkTableColumnAttributeType (propName) { // 检查表格列类型
            for (let i = 0; i < this.tableColumnAttributes.length; i++) {
                if (this.tableColumnAttributes[i].prop === propName) {
                    return this.tableColumnAttributes[i].type || 'String'
                }
            }
            return 'String'
        }
    },
    mounted() {
    }
}
</script>

<style scoped>

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/Pages/PageTable/PageTableItem.vue"
}
</vue-filename-injector>
